module.exports = __webpack_public_path__ + "static/media/judith.c55a6aab.jpg";